/*
Use this hack to set the user attributes in the AuthProvider.
Cannot run firestore queries in AuthProvider because authenticated queries need useAuth -- which only works
when in a child component of AuthProvider.
*/
import React, { useEffect } from "react";
import { useGetUserAttributesQuery } from "../slices/api/usersApi";
import { useAuth } from "../authentication/AuthProvider";
import { useMantineColorScheme } from "@mantine/core";

export const UserAttributesHack: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const authContext = useAuth();
  const { setColorScheme } = useMantineColorScheme();
  const { data: userAttributesResponse } = useGetUserAttributesQuery(
    {},
    { skip: authContext?.user == null }
  );

  useEffect(() => {
    authContext.setUserAttributes({
      firstName: userAttributesResponse?.firstName!,
      lastName: userAttributesResponse?.lastName,
      displayMode: userAttributesResponse?.displayMode!,
      canOwnVents: userAttributesResponse?.canOwnVents,
      isUnsubscribedAll: userAttributesResponse?.isUnsubscribedAll ?? false,
      unsubscribedHosts: userAttributesResponse?.unsubscribedHosts ?? [],
      isAdmin: userAttributesResponse?.isAdmin ?? false,
      emailAllotment: userAttributesResponse?.emailAllotment ?? 0,
      ventLimit: userAttributesResponse?.ventLimit ?? 0,
      guestLimit: userAttributesResponse?.guestLimit ?? 0,
      isOptedOutTextChannel:
        userAttributesResponse?.isOptedOutTextChannel ?? false,
      canTestTextChannel: userAttributesResponse?.canTestTextChannel ?? false,
      smsNumber: userAttributesResponse?.smsNumber ?? "",
      userId: userAttributesResponse?.userId ?? "",
    });
    switch (userAttributesResponse?.displayMode) {
      case "s":
        setColorScheme("auto");
        break;
      case "d":
        setColorScheme("dark");
        break;
      case "l":
        setColorScheme("light");
        break;
    }
  }, [userAttributesResponse]);

  return <>{children}</>;
};
